<div class="layout">
  <header>
    <app-navbar />
  </header>

  <main><router-outlet /></main>

  <footer><app-footer /></footer>
</div>
